import { gql } from '@apollo/client';

export const fetchInvoiceGroupDetailsPPCQuery = gql`
  query fetchInvoiceGroupDetailsPPC($id: ID!, $txaId: ID) {
    invoiceGroup(id: $id, txaId: $txaId) {
      id
      name
      invoiceGroupNumber
      termPaymentStatus {
        status
      }
      shipToParty {
        id
        name
        addressLine1
        city
        country
        state
        postcode
        taxIds {
          id
          label
          taxExempt
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
            metadata {
              type
              labels {
                default
                label
                vatStatus
              }
            }
          }
        }
      }
      defaultPaymentMethod {
        id
        type
        default
        ... on CreditCard {
          card {
            last4Numbers
            expirationMonth
            expirationYear
            cardHolderName
            brand
          }
        }
        ... on PaymentOnTerms {
          terms {
            invoiceDueDays
            payOnStatement
          }
          totalCreditLimit
          paymentMethod
        }
        ... on PayPal {
          payPal {
            name
            email
          }
        }
      }
    }
  }
`;
